import HardResetWatchDeviceModal from './HardResetWatchDeviceModal'

export default HardResetWatchDeviceModal
